import { useContext } from 'react'
import StateContext from '../StateContext'
import { Link } from 'react-router-dom'
import { useTranslation, withTranslation } from 'react-i18next'
function SidebarBanner(props) {
    const {t} = useTranslation()
    const appState = useContext(StateContext)
    return (
        <>
            {/* bannerSection */}
            <div className="bannerSection">
                {/* innerBanner */}
                <div className="innerBanner">
                    {/* bannerImg */}
                    <div className="bannerImg" style={{ backgroundImage: `url('${process.env.REACT_APP_IMAGE_URL}bannerMob.png')` }}>

                    </div>
                    {/* banenrContent */}
                    <div      style={{display:"none"}} className="banenrContent">
                        <div className="container">
                            <h3><strong>{props.message_secondary}</strong></h3>
                            {/* <h5>{props.other_message}</h5> */}
                            <Link to="/wallet">
                                <div className="sidebar-button sidebar-wallet-amount">
                                    <i className="fas fa-wallet"></i> {appState.profile.walletAmount ? parseFloat(appState.profile.walletAmount) : '0'} {t("KWD")}
                                </div>
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
export default withTranslation() (SidebarBanner)